import { css } from 'styled-components';

const resetList = css(["list-style:none;margin:0;padding:0;"]);

export { resetList };
//# sourceMappingURL=resetList.js.map
